export function getWithoutHtmlTags(textWithHtmlTags: string): string {
    return textWithHtmlTags
        .slice()
        .replace(/<(.|\n)*?>/g, '')
        .trim();
}
